import React from 'react';
import { FormattedMessage } from 'react-intl';
import IndexContainer from 'components/place/index_container';
import BreadcrumbContainer from 'components/layout/breadcrumb_container';
import { BreadCrumbTypography } from 'components/styles_components/typography';
import { PaginateProvider } from 'contexts/paginate';
import Container from 'components/layout/container';
import TopMenu from 'components/layout/top_menu';

const Places = () => {
  return (
    <PaginateProvider>
      <TopMenu>
        <BreadcrumbContainer>
          <BreadCrumbTypography>
            <FormattedMessage id="breadcrumb.place.index" />
          </BreadCrumbTypography>
        </BreadcrumbContainer>
      </TopMenu>
      <Container>
        <IndexContainer />
      </Container>
    </PaginateProvider>
  );
};

export default Places;
